export default "__VITE_ASSET__CZ$eY1J3__"